import React from "react"
import { Heading } from "react-bulma-components"
import ContentPage from "./ContentPage"

const Terms: React.FC = () => {
  return (
    <ContentPage>
      This page outlines how my resource packs can and cannot be used.
      <br />
      <br />
      <Heading subtitle size={4} id="you-may">
        You may:
      </Heading>
      <ul>
        <li>
          Use my resource packs for personal use and on multiplayer servers.
        </li>
        <li>
          Combine assets from my resource packs for personal mashup packs, so
          long as they <strong>are not</strong> distributed.
        </li>
        <li>
          Use my resource packs in videos and streams without credit. A link to
          my Planet Minecraft page would be appreciated but is not required.
        </li>
      </ul>
      <br />
      <br />
      <Heading subtitle size={4} id="you-may-not">
        You may not:
      </Heading>
      <ul>
        <li>
          Distribute assets from my resource packs without explicit permission.
          This includes in public mashup packs, or in resource packs you are
          making.
        </li>
        <li>Share any assets I made behind a paywall (e.g. ad links)</li>
      </ul>
      <br />
      <br />
      <Heading subtitle size={4} id="credit">
        Credit
      </Heading>
      If you have been given permission to use assets that I made in a resource
      pack you are making, you must credit me (Beatso) and include a link to the
      website from which someone can download the assets that I made, such as
      the Planet Minecraft page for that submission. This should be done on the
      website from which you are distributing your resource pack, and in a{" "}
      <code>credits.txt</code> file inside the pack.
    </ContentPage>
  )
}

export default Terms
